import { Widget } from "dashboard-assistant";
import { percentage } from "./utils";

function makeWidgetElem(item: Widget): HTMLDivElement {
    let elem = document.createElement("div");
    elem.classList.add("widget");
    elem.innerHTML += `<h3>${item.widget}</h3>`;
    return elem;
}

export function makeWidgetContainer(items: Widget[], aspect: number = 1.0): HTMLDivElement {
    if (items.length <= 1) {
        return makeWidgetElem(items[0]);
    }

    let container = document.createElement("div");
    container.classList.add("widget-container");

    let weight_sum = 0.0;
    for (const w of items) {
        weight_sum += w.weight;
    }

    let split_index = 1;
    let weight_accum = items[0].weight;
    for (const w of items.slice(1, -1)) {
        if (weight_accum >= weight_sum / 2.0) {
            break;
        }
        weight_accum += w.weight;
        split_index += 1;
    }
    const fraction = weight_accum / weight_sum;

    let [first_aspect, second_aspect] = [1.0, 1.0];
    if (aspect > 1.0) {
        first_aspect = aspect * fraction;
        second_aspect = aspect * (1.0 - fraction);
    } else {
        first_aspect = aspect / fraction;
        second_aspect = aspect / (1.0 - fraction);
    }

    let first = makeWidgetContainer(items.slice(0, split_index), first_aspect);
    let second = makeWidgetContainer(items.slice(split_index), second_aspect);

    if (aspect > 1.0) {
        first.style.width = percentage(fraction);
        second.style.width = percentage(1.0 - fraction);
        second.style.left = first.style.width;
    } else {
        first.style.height = percentage(fraction);
        second.style.height = percentage(1.0 - fraction);
        second.style.top = first.style.height;
    }

    container.appendChild(first);
    container.appendChild(second);

    return container;
}
